export interface State {
  active: boolean;
  __typename: "AccountSettingsTab";
}

export const defaultState: State = {
  active: false,
  __typename: "AccountSettingsTab"
};
